/* eslint-disable jira/filename-case */
// Jira platform project feedback JSD widget configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JGF/queues/custom/448
export const ENTRYPOINT_ID_JIRA_PLATFORM = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';

// GIC AI field suggestions feedback configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/AISF/queues/custom/7663
export const ENTRYPOINT_ID_GIC_AI_FIELD_SUGGESTIONS = '5d198c09-f525-4eb1-8e33-f277c4050a8e';

// Jira software project
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JSF/queues/custom/289
export const ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT = 'f60db8bd-1904-4af4-a0ef-f140598ebada';

// Jira Product Discovery
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JPD/queues/custom/626
export const ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY = '3508b77a-0aa1-4ad5-a397-621bd308c828';

// JSD Project: https://customerfeedback.atlassian.net/jira/servicedesk/projects/JSMF/queues/custom/764
export const ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';

// JSD Project: https://customerfeedback.atlassian.net/jira/servicedesk/projects/JCPF/queues/custom/767
export const ENTRYPOINT_ID_JIRA_COMMAND_PALETTE = '3d204590-d14a-419f-a042-f0b1a92e005b';

// JSD Project: https://customerfeedback.atlassian.net/jira/servicedesk/projects/JBF/
export const ENTRYPOINT_ID_JIRA_ISSUE_VIEW = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';

// JSD Project: https://customerfeedback.atlassian.net/browse/NCF
export const ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';

// Generative AI feedback configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/GAIE/queues/custom/891
export const ENTRY_POINT_ID_GENERATIVE_AI = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';

// Jira Space Create feedback configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JSCA
export const ENTRY_POINT_ID_JIRA_SPACE_CREATE = '4cd73d76-ada3-4ecc-8060-ba3113b3e96c';

// AIOps Customer Feedback
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/ACC/queues/custom/1107
export const ENTRY_POINT_ID_AIOPS = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';

// Compass feedback configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/COMPASSFB/queues/custom/449
export const ENTRY_POINT_ID_COMPASS = 'e6321572-aa72-47b3-b261-e142b81ad4b2';

// JSM Assets Reporting Configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/IPJR/queues/custom/966
export const ENTRY_POINT_ID_JSM_ASSETS_REPORTING = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';

// JSM Virtual Service Agent
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/VAF/queues/custom/970
export const ENTRY_POINT_ID_JSM_VIRTUAL_AGENT = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';

// Navigation refresh customer feedback
// JSD Project: https://customerfeedback.atlassian.net/jira/servicedesk/projects/NAV4/queues
export const ENTRYPOINT_ID_NAVIGATION_REFRESH = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';

// JSM RT page customer feedback
// JSM Project: https://customerfeedback.atlassian.net/jira/servicedesk/projects/JSMRTP/queues/
export const ENTRY_POINT_ID_REQUEST_TYPES_PAGE = 'ee8a71e7-85aa-4121-b455-e6316922e894';

// Project backgrounds feedback
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/PROJBG/queues/custom/3312
export const ENTRYPOINT_ID_PROJECT_BACKGROUNDS = 'd0f0863a-fe78-4d40-b4f0-451c268594cc';

// JSM Journey Builder customer feedback
// JSM Project: https://customerfeedback.atlassian.net/jira/servicedesk/projects/JSMJB/queues/
export const ENTRY_POINT_ID_JOURNEY_BUILDER = 'd5f62dde-d505-413b-a417-c2dd6979cac2';

// JSM Playbooks customer feedback
// JSM Project: https://customerfeedback.atlassian.net/jira/servicedesk/projects/JP/queues/custom/6687
export const ENTRY_POINT_ID_PLAYBOOKS = 'e578a125-130e-4762-9556-2acb236a12cc';

// Bulk Operations customer feedback
// JSM Project: https://customerfeedback.atlassian.net/jira/servicedesk/projects/BULKOPSFP/queues/
export const ENTRY_POINT_ID_BULK_OPERATIONS = '106df6fd-feed-4aa7-bbf7-5ca2bec6266b';

// Bulk Operations Merge panel customer feedback
// JSM Project: https://customerfeedback.atlassian.net/jira/servicedesk/projects/JBM/queues/custom/6763
export const ENTRY_POINT_ID_BULK_OPERATIONS_MERGE_PANEL = 'c1880d75-c7ba-40e6-850f-1355c8ac2b22';

// Jira Admin Onboarding Hub
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JIRAONBRFP/queues/custom/4053
export const ENTRY_POINT_ID_ADMIN_ONBOARDING_HUB = '7620f432-f831-4711-8e09-3aa379bf2d96';

// AI Context Resolution Plan Panel customer feedback
// JSM Project: https://customerfeedback.atlassian.net/jira/servicedesk/projects/AIRPPFC/queues/custom/4071
export const ENTRY_POINT_ID_AI_CONTEXT_RESOLUTION_PLAN_PANEL =
	'a8c2aa57-6975-4ed7-80c6-42f46f0bdf91';

// Capacity tab in Jira Spaces
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JCAP/queues/custom/4278
export const ENTRY_POINT_ID_INDIVIDUAL_CAPACITY_PLANNING = 'aab1458f-e9f0-49e0-b86e-b191e9186a4a';

// Jira Horizontal nav
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JHNF/queues/custom/6009
export const ENTRY_POINT_ID_HORIZONTAL_NAV = '9c1d7477-03c3-4266-8f32-44c536b4d4b4';

// Space policies (site admin governance + space-level settings)
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JSP/queues/custom/8990
export const ENTRY_POINT_ID_SPACE_POLICIES = 'f427140b-75a3-49ff-b4c9-48514f7e6f75';

// JSM SLA configuration redesign customer feedback
// JSM Project: https://customerfeedback.atlassian.net/jira/servicedesk/projects/JSCV
export const ENTRY_POINT_ID_JSM_SLA_CONFIGURATION = 'a9da57f4-f57b-4c15-a0d2-b30bcf899b7c';

export const EntryKeys: Readonly<{
	readonly CLOUD_ID: 'cloud-id';
	readonly OPT_OUT: 'Opt-out';
	readonly REASON: 'reason';
	readonly FEELING: 'feeling';
	readonly IS_ADMIN: 'is-admin';
	readonly IS_ANONYMOUS: 'is-anonymous';
	readonly IS_SITE_ADMIN: 'is-site-admin';
	readonly IS_PROJECT_SETTINGS: 'is-project-settings';
	readonly INLINE_FEEDBACK_ID: 'inlineFeedbackId';
	readonly IS_JSD_EVALUATOR: 'is-jsd-evaluator';
	readonly IS_SIMPLIFIED_PROJECT: 'is-simplified-project';
	readonly SUPPORTED_PROJECT_TYPES: 'supported-project-types';
	readonly FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location';
	readonly FEEDBACK_COLLECTOR_ID: 'feedback-collector-id';
	readonly FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key';
	readonly LOCATION: 'Location';
	readonly PROJECT_TYPE: 'project-type';
	readonly BOARD_TYPE: 'board-type';
	readonly REFERER: 'Referer';
	readonly ROUTE_GROUP: 'route-group';
	readonly ROUTE_NAME: 'route-name';
	readonly USER_AGENT: 'User-Agent';
	readonly SCREEN_RESOLUTION: 'Screen Resolution';
	readonly SOURCE: 'Source';
	readonly SUB_PRODUCT: 'Sub-product';
	readonly JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow';
	readonly JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign';
	readonly DEPLOYMENT_PROVIDERS: 'deployment-providers';
	readonly JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar';
	readonly VERSION_CONTROL_PROVIDERS: 'version-control-providers';
	readonly DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab';
	readonly CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers';
	readonly SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers';
	readonly INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers';
	readonly IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component';
	readonly FEEDBACK_GROUP_ID: 'feedback-group-id';
	readonly EDITION: 'edition';
	readonly ENV: 'environment';
	readonly SMART_REPLIES: 'smart-replies';
	readonly PROJECT_RECAP_FEEDBACK_GROUP_ID: 'jira-notifications-project-recap';
	readonly STANDUPS: 'standups';
	readonly SUMMARY_VARIANT: 'summary-variant';
}> = Object.freeze({
	CLOUD_ID: 'cloud-id',
	OPT_OUT: 'Opt-out',
	REASON: 'reason',
	FEELING: 'feeling',
	IS_ADMIN: 'is-admin',
	IS_ANONYMOUS: 'is-anonymous',
	IS_SITE_ADMIN: 'is-site-admin',
	IS_PROJECT_SETTINGS: 'is-project-settings',
	INLINE_FEEDBACK_ID: 'inlineFeedbackId',
	IS_JSD_EVALUATOR: 'is-jsd-evaluator',
	IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
	SUPPORTED_PROJECT_TYPES: 'supported-project-types',
	FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
	FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
	FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
	LOCATION: 'Location',
	PROJECT_TYPE: 'project-type',
	BOARD_TYPE: 'board-type',
	REFERER: 'Referer',
	ROUTE_GROUP: 'route-group',
	ROUTE_NAME: 'route-name',
	USER_AGENT: 'User-Agent',
	SCREEN_RESOLUTION: 'Screen Resolution',
	SOURCE: 'Source',
	SUB_PRODUCT: 'Sub-product',
	JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
	JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
	DEPLOYMENT_PROVIDERS: 'deployment-providers',
	JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
	VERSION_CONTROL_PROVIDERS: 'version-control-providers',
	DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
	CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
	SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
	INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
	IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
	FEEDBACK_GROUP_ID: 'feedback-group-id',
	EDITION: 'edition',
	ENV: 'environment',
	SMART_REPLIES: 'smart-replies',
	PROJECT_RECAP_FEEDBACK_GROUP_ID: 'jira-notifications-project-recap',
	STANDUPS: 'standups',
	SUMMARY_VARIANT: 'summary-variant',
} as const);
